import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'PARAM_ENT',
  title: 'Wie kann ich meine Firmeneinstellungen ändern?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Um auf Ihre Firmeneinstellungen zuzugreifen, klicken Sie auf die Registerkarte "Einstellungen":'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_PARAM_ENT/DE_PARAM_ENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Sie gelangen dann auf die Einstellungsseite Ihrer Firma, die Sie einsehen können. Um diese Einstellungen zu ändern, müssen Sie eine Anfrage an den Kundendienst stellen, indem Sie auf "Kundendienst kontaktieren" klicken und Ihre Änderungsanfrage stellen:'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_PARAM_ENT/DE_PARAM_ENT_2.png`
  }]
};
